// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.456165ac',
  revision: '456165ac',
  branch: 'develop',
  date: 'Mon, 06 Apr 2026 12:52:18 GMT'
};